import axios from "axios";
import { toAbsoluteRestUrl } from "../../_metronic/utils/utils";

export const ME_URL = toAbsoluteRestUrl("/me");

export function getUserByToken() {
  return axios.get(ME_URL);
}
